import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["altText", "partnerTier"];
import { View } from 'foundations-components/components/View';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!marketplace-ui-detai.. Remove this comment to see the full error message
import LeadingIcon from 'bender-url!marketplace-ui-details/img/Tier_Leading.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!marketplace-ui-detai.. Remove this comment to see the full error message
import PremierIcon from 'bender-url!marketplace-ui-details/img/Tier_Premier.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!marketplace-ui-detai.. Remove this comment to see the full error message
import RisingIcon from 'bender-url!marketplace-ui-details/img/Tier_Rising.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!marketplace-ui-detai.. Remove this comment to see the full error message
import UntieredIcon from 'bender-url!marketplace-ui-details/img/Tier_Partner.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_MAP = {
  LEADING: LeadingIcon,
  PREMIER: PremierIcon,
  RISING: RisingIcon,
  PARTNER: UntieredIcon
};
export function PartnerTierIcon(_ref) {
  let {
      altText,
      partnerTier
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx("img", {
      style: {
        objectFit: 'contain',
        width: '100%',
        height: '100%'
      },
      src: ICON_MAP[partnerTier],
      alt: altText
    })
  }));
}